import { supabase, supabaseConfigError } from './supabase'

const buildCoursePayload = (values, curriculumId, orderIndexOverride = null) => ({
  curriculum_id: curriculumId,
  name: values.name?.trim() || '',
  description: values.description?.trim() || '',
  estimated_duration: values.estimated_duration?.trim() || '',
  order_index: orderIndexOverride ?? values.order_index ?? 0
})

export const fetchCoursesForCurriculum = async (curriculumId) => {
  if (!curriculumId) {
    return { data: [], error: null }
  }
  if (supabaseConfigError) {
    return { data: null, error: supabaseConfigError }
  }

  return supabase
    .from('courses')
    .select('*')
    .eq('curriculum_id', curriculumId)
    .order('order_index', { ascending: true })
}

export const createCourse = async (curriculumId, values, nextOrderIndex = 0) => {
  if (supabaseConfigError) {
    return { data: null, error: supabaseConfigError }
  }

  const payload = buildCoursePayload(values, curriculumId, nextOrderIndex)
  return supabase.from('courses').insert([payload]).select().single()
}

export const updateCourse = async (courseId, values) => {
  if (supabaseConfigError) {
    return { data: null, error: supabaseConfigError }
  }

  const payload = buildCoursePayload(values, values.curriculum_id, values.order_index)
  return supabase.from('courses').update(payload).eq('id', courseId).select().single()
}

export const deleteCourse = async (courseId) => {
  if (supabaseConfigError) {
    return { error: supabaseConfigError }
  }

  return supabase.from('courses').delete().eq('id', courseId)
}

export const reorderCourses = async (curriculumId, orderedCourseIds) => {
  if (supabaseConfigError) {
    return { data: null, error: supabaseConfigError }
  }

  const payload = orderedCourseIds.map((id, index) => ({
    id,
    curriculum_id: curriculumId,
    order_index: index
  }))

  return supabase.from('courses').upsert(payload).select()
}
